import MobileDrawer from '@c/drawers/MobileDrawer';
import AektivTradeInForm from './form/aektivTradeInForm';

type MobileAektivTradeInModalProps = {
  open: boolean;
  dismiss: () => void;
};

export default function MobileAektivTradeInModal({
  open,
  dismiss,
}: MobileAektivTradeInModalProps) {
  return (
    <MobileDrawer show={open} dismiss={dismiss} title="Aektiv Trade-In Program">
      <div className="flex flex-col gap-y-8 p-8">
        <p className="w-[46rem] pr-4 text-[1.8rem] font-medium text-zinc-600">
          After submitting this form, a message thread with our trade in team
          will open and we will be in touch with you shortly.
        </p>

        <AektivTradeInForm dismiss={dismiss} />
      </div>
    </MobileDrawer>
  );
}
